import { Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';


const InvolvedVehicle = (props: any) => {
    const [itemIndex, setItemIndex] = useState<number>(props.index ? props.index : 0);
    const [vehicle, setVehicle] = useState<any>(props.vehicle);
    const [insuranceCompanyLabel, setInsuranceCompanyLabel] = useState<string>('')

    const onInvolvedVehicleChange = (e: any, paramName: string, index: number, isNumber: boolean = false) => {
        const newValue = e.target.value;
        const vData = {...vehicle};
        vData[paramName] = newValue;
        setVehicle(vData);
        if (props.onInvolvedVehicleChange) {
            props.onInvolvedVehicleChange(e, paramName, itemIndex);
        }
    }

    const onIsDefendantCompanyChange = (value: string, option: { label: string; value: string; }, index: number =0) => {
        const vData = {...vehicle};
        vData.isThirdPartyDefendantCompany = value == '1' ? true : false;
        setVehicle(vData);
        if (props.onIsDefendantCompanyChange) {
            props.onIsDefendantCompanyChange(value, option, itemIndex);
        }
    }

    const onTypeOfVehicleChange = (value: string, option: { label: string; value: string; }, index: number =0) => {
        const vData = {...vehicle};
        vData.thirdPartyTypeOfVehicle = parseInt(value);
        setVehicle(vData);
        if (props.onTypeOfVehicleChange) {
            props.onTypeOfVehicleChange(value, option, itemIndex);
        }
    }

    const onInvolvedVehicleInsuranceCompanyChange = (e: any, index: number = 0) => {
        const companyName = e.target.value;
        setInsuranceCompanyLabel(companyName);
        const vData = {...vehicle};
        const selected = props.insuranceCompanies.find((a: any)=> a.label == companyName);
        if(selected) {
            vData.thirdPartyInsuranceCompanyId = selected.value;
            setInsuranceCompanyLabel(selected.label);
        } else {
            vData.thirdPartyInsuranceCompanyId = null;
        }
        console.log('onInvolvedVehicleInsuranceCompanyChange-itemIndex', itemIndex)
        setVehicle(vData);
        if (props.onInvolvedVehicleInsuranceCompanyChange) {
            props.onInvolvedVehicleInsuranceCompanyChange(e, itemIndex);
        }
    }

    const onClearInvolvedVehicleInsuranceCompany = (index: number = 0) =>{
        const vData = {...vehicle};
        vData.thirdPartyInsuranceCompanyId = null;
        setVehicle(vData);
        setInsuranceCompanyLabel('');

        if (props.onClearInvolvedVehicleInsuranceCompany) {
            props.onClearInvolvedVehicleInsuranceCompany(itemIndex);
        }
    }

    const onInvolvedVechicleCheck = (e: any, index: number = 0) => {
        if (props.onInvolvedVechicleCheck) {
            props.onInvolvedVechicleCheck(e, itemIndex);
        }
    }

    useEffect(()=>{
        setVehicle(props.vehicle);
        console.log('InvolvedVehicle props changed',props.vehicle)
        const selectedInsuranceCompany = props.insuranceCompanies.find((a: any)=> a.value == props.vehicle.thirdPartyInsuranceCompanyId);
        if (selectedInsuranceCompany) {
            setInsuranceCompanyLabel(selectedInsuranceCompany.label);
        }
    }, [props.vehicle])

    useEffect (()=>{
        console.log('InvolvedVehicle init')
    },[])
    return (
        <>
        <div className="parameter-row">
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    האם הנתבעת היא החברה של צד ג'
                    </div>
                    <div className="value">
                        <Select
                            style={{ width: '100%' }}
                            placeholder=""
                            value={vehicle && vehicle.isThirdPartyDefendantCompany ? '1' : '0'}
                            onChange={(value: string, option: any)=>onIsDefendantCompanyChange(value, option, itemIndex)}
                            options={[
                                {
                                    label: 'כן',
                                    value: '1'
                                },
                                {
                                    label: 'לא',
                                    value: '0'
                                }]
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        שם הסוכן
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyAgentName ? vehicle.thirdPartyAgentName : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyAgentName', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    טל. הסוכן
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyAgentPhone ?vehicle.thirdPartyAgentPhone : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyAgentPhone', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    מס' תביעה צד ג'
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartySueNumber ? vehicle.thirdPartySueNumber : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartySueNumber', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item"></div>
        </div>
        <div className="parameter-row">
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    מס רישוי
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyLicensePlateNumber ? vehicle.thirdPartyLicensePlateNumber : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyLicensePlateNumber', 0 )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>

<div className="parameter-item">
                <div className="field">
                    <div className="title">
                    שנה 
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyYear ? vehicle.thirdPartyYear : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyYear', 0 )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>

            
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    שם הדגם
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyCarModel ? vehicle.thirdPartyCarModel : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyCarModel', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        סוג הרכב
                    </div>
                    <div className="value">
                        <Select
                            style={{ width: '100%' }}
                            placeholder=""
                            value={vehicle && vehicle.thirdPartyTypeOfVehicle >= 0  ? vehicle.thirdPartyTypeOfVehicle.toString() : '0'}
                            onChange={(value: string, option: any)=>onTypeOfVehicleChange(value, option, itemIndex)}
                            options={[
                                { label: 'רכב פרטי',
                                    value: '0'
                                },
                                {
                                    label: 'מסחרי',
                                    value: '1'
                                }]
                            }
                        />

                        {/* <Select
                                                                    style={{ width: '100%' }}
                                                                    placeholder=""
                                                                    value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 ? 
                                                                        getThirdPartyVehicleTypeValue(sueData.involvedVehiclesList[0].thirdPartyTypeOfVehicle) : ''}
                                                                    onChange={(value: string)=>onInvolvedVehicleTypeChange(value, 'thirdPartyTypeOfVehicle', 0 )}
                                                                    options={typeOfCars}
                                                                /> */}
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        חברת ביטוח צד ג'
                    </div>
                    <div className="value">
                        <input type='text'
                                    list={`companies_list${itemIndex}`}
                                    placeholder='בחר חברת ביטוח'
                                    onChange={(e)=>onInvolvedVehicleInsuranceCompanyChange(e, itemIndex)}
                                    value={insuranceCompanyLabel}
                                />
                        <datalist id={`companies_list${itemIndex}`}>
                            {props.insuranceCompanies && props.insuranceCompanies.map((c: any, i: number)=><option key={i} value={c.label}>{c.label}</option>)}
                        </datalist>
                        <div className={`icon x-clear pointer ${insuranceCompanyLabel == '' ? 'hide' : ''}`} onClick={()=>onClearInvolvedVehicleInsuranceCompany(itemIndex)}></div>
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    מס' פוליסה
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyPolicyName ? vehicle.thirdPartyPolicyName : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyPolicyName', itemIndex, true )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
        </div>
        <div className="parameter-row">
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        שם בעל הרכב
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyCarOwnerName ? vehicle.thirdPartyCarOwnerName : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyCarOwnerName', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    מס' ת.ז. של בעל רכב
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyOwnerIdentifier ? vehicle.thirdPartyOwnerIdentifier : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyOwnerIdentifier', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        טלפון
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyCarOwnerPhone ? vehicle.thirdPartyCarOwnerPhone : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyCarOwnerPhone', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        נייד
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyCarOwnerMobile ? vehicle.thirdPartyCarOwnerMobile :''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyCarOwnerMobile', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    כתובת
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.thirdPartyOwnerAddress ? vehicle.thirdPartyOwnerAddress : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'thirdPartyOwnerAddress', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
        </div>
        {/* <div className="parameter-row">
            
            <div className="parameter-item"></div>
            <div className="parameter-item"></div>
            <div className="parameter-item"></div>
        </div> */}
        <div className="parameter-row">
            <div className="parameter-item">
                <input type="checkbox" checked={vehicle && vehicle.isDriverOwnerOfTheVehicle} onChange={(e:any)=>onInvolvedVechicleCheck(e, itemIndex)} className="checkbox-input" name="is-car-owner" value="1" />
                הנהג הוא בעל רכב
            </div>
            <div className="parameter-item"></div>
            <div className="parameter-item"></div>
            <div className="parameter-item"></div>
            <div className="parameter-item"></div>
        </div>
        <div className="parameter-row">
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    שם נהג
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.driverName ? vehicle.driverName : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'driverName', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    כתובת
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.driverAddress ? vehicle.driverAddress : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'driverAddress', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        מס' ת.ז.
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.driverIdentifier ? vehicle.driverIdentifier : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'driverIdentifier', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                        מס' רשיון
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.licenseNumber ? vehicle.licenseNumber : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'licenseNumber', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    טלפון
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.driverPhone1 ? vehicle.driverPhone1 : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'driverPhone1', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="title">
                    נייד
                    </div>
                    <div className="value">
                    <input type="text" value={vehicle && vehicle.driverPhone2 ? vehicle.driverPhone2 : ''} onChange={(e:any)=>onInvolvedVehicleChange(e, 'driverPhone2', itemIndex )} onBlur={(e:any)=>{}} />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default InvolvedVehicle;